var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21A10.5 10.5 0 1121 10.5 10.511 10.511 0 0110.5 21zm0-19.865a9.365 9.365 0 109.365 9.365A9.376 9.376 0 0010.5 1.136z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.329 14.482a.569.569 0 01-.4-.166l-3.421-3.415a.567.567 0 11.8-.8l3.014 3.008 5.36-5.527a.568.568 0 11.814.791l-5.76 5.94a.565.565 0 01-.4.173z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRounded);
export default __webpack_public_path__ + "static/media/check_rounded.75e26dba80d1d9b1a3c7e6019b4f3a86.svg";
export { ForwardRef as ReactComponent };